var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappGreyTicks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62646 3.8468C9.8739 3.53886 10.3241 3.4893 10.6323 3.73645C10.9404 3.98373 10.9905 4.43403 10.7437 4.74231L4.55811 12.4474C4.43089 12.6059 4.24247 12.7028 4.03955 12.714C3.8366 12.7251 3.63843 12.6496 3.49463 12.506L0.994629 10.006C0.715107 9.72647 0.714172 9.27283 0.993652 8.99329C1.27311 8.71399 1.72685 8.71405 2.00635 8.99329L3.94189 10.9288L9.62646 3.8468ZM13.7124 3.8468C13.9599 3.53864 14.411 3.48904 14.7192 3.73645C15.0272 3.98379 15.0765 4.43409 14.8296 4.74231L8.64404 12.4474C8.51677 12.6059 8.32847 12.7029 8.12549 12.714C7.9225 12.7251 7.72437 12.6497 7.58057 12.506L6.58057 11.507C6.30122 11.2276 6.30062 10.7738 6.57959 10.4943C6.85899 10.2149 7.31272 10.2142 7.59229 10.4933L8.02783 10.9279L13.7124 3.8468Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappGreyTicks);
export default __webpack_public_path__ + "static/media/whatsapp-grey-ticks.e3c4210bcc8e95df1588d76748a35aab.svg";
export { ForwardRef as ReactComponent };